import React, { useContext, useState } from "react";
import useDashboardQuery from "../../../hooks/useDashboardQuery";
import CompanyQueriesModal from "../../modals/dashboard-queries/CompanyQueriesModal";
import DescriptionAnswer from "../dashboard-query-answer/DescriptionAnswer";
import BasicTextQueryContainer from "../dashboard-query-container/BasicTextQueryContainer";
import { DashboardContext } from "../../../contexts/DashboardContext";

const DescriptionQuery: React.FC<{}> = () => {
    const { isPublicView } = useContext(DashboardContext);
    const { queryAnswer, updateQuery } = useDashboardQuery('Description');
    const [modalOpen, setModalOpen] = useState<boolean>(false);

    return (<>
        <BasicTextQueryContainer
            queryAnswer={queryAnswer}
            displayMenu={!isPublicView}
            onEdit={updateQuery}>
            <DescriptionAnswer answeredQuestion={queryAnswer.answeredQuestion} onModal={setModalOpen} />
        </BasicTextQueryContainer>
        {modalOpen && (
            <CompanyQueriesModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
        )}
    </>);
}

export default DescriptionQuery;
